import { RpaLicenseEntityModel } from "src/store/models/entity/rpaLicense/entity";
import { RpaLicenseHelperModel } from "src/store/models/entity/rpaLicense/helper";

export const encooRpaLicenseModels = {
  entity: RpaLicenseEntityModel,
  helper: RpaLicenseHelperModel,
};
